// extracted by mini-css-extract-plugin
export var addbreedsicon = "DogSearch-module--addbreedsicon--779f6";
export var breedorlocationselector = "DogSearch-module--breedorlocationselector--67d1b";
export var breedselectedcount = "DogSearch-module--breedselectedcount--33ec3";
export var breedtext = "DogSearch-module--breedtext--60769";
export var distancecontainer = "DogSearch-module--distancecontainer--f45a7";
export var distancecontrols = "DogSearch-module--distancecontrols--9658d";
export var distancerange = "DogSearch-module--distancerange--dc38c";
export var distanceselect = "DogSearch-module--distanceselect--1d91e";
export var dogsearch = "DogSearch-module--dogsearch--f5719";
export var filteroption = "DogSearch-module--filteroption--6f4f9";
export var filteroptions = "DogSearch-module--filteroptions--86d95";
export var filteroptionsstacked = "DogSearch-module--filteroptionsstacked--8967d DogSearch-module--filteroptions--86d95";
export var filteroptionstacked = "DogSearch-module--filteroptionstacked--e092e DogSearch-module--filteroption--6f4f9";
export var label = "DogSearch-module--label--fcb07";
export var leftalign = "DogSearch-module--leftalign--13181";
export var loadingbackground = "DogSearch-module--loadingbackground--e6812";
export var loadingicon = "DogSearch-module--loadingicon--9683e";
export var loadingoverlay = "DogSearch-module--loadingoverlay--cd77e";
export var searchinput = "DogSearch-module--searchinput--2e681";
export var showdogsbutton = "DogSearch-module--showdogsbutton--c2cbd";
export var title = "DogSearch-module--title--9bc16 headings-module--sectionHeading--a8f67";
export var viewmore = "DogSearch-module--viewmore--75980";